import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      {
        title:
          "Liquid Screed Exeter | Fast Curing & Free Quotes | Exeter Flow Screed",
      },
      {
        name: "description",
        content:
          "Cemfloor certified liquid screed installers in Exeter & Devon. Fast-curing, level floors for underfloor heating & renovations. Get your free fixed quote today!",
      },
      {
        property: "og:title",
        content:
          "Liquid Screed Exeter | Fast Curing & Free Quotes | Exeter Flow Screed",
      },
      {
        property: "og:description",
        content:
          "Cemfloor certified liquid screed installers in Exeter & Devon. Fast-curing, level floors for underfloor heating & renovations. Get your free fixed quote today!",
      },
      {
        property: "og:url",
        content: "https://exeterflowscreed.co.uk/",
      },
      {
        property: "og:image",
        content:
          "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6a7469d1e76789340f9e87b3.webp",
      },
      {
        name: "twitter:title",
        content:
          "Liquid Screed Exeter | Fast Curing & Free Quotes | Exeter Flow Screed",
      },
      {
        name: "twitter:description",
        content:
          "Cemfloor certified liquid screed installers in Exeter & Devon. Fast-curing, level floors for underfloor heating & renovations. Get your free fixed quote today!",
      },
      {
        name: "twitter:image",
        content:
          "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6a7469d1e76789340f9e87b3.webp",
      },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://exeterflowscreed.co.uk/",
      },
    ],
  }),
  component: Index,
});
